import { render, staticRenderFns } from "./costHelpThirtyTage.vue?vue&type=template&id=99d410f6&"
import script from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d410f6')) {
      api.createRecord('99d410f6', component.options)
    } else {
      api.reload('99d410f6', component.options)
    }
    module.hot.accept("./costHelpThirtyTage.vue?vue&type=template&id=99d410f6&", function () {
      api.rerender('99d410f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2H3teQrewuxPk/JS/costHelpThirtyTage.vue"
export default component.exports